module.exports = __webpack_public_path__ + "static/media/hot-air-balloons.8d7c545f.jpg";